<template>
      <v-dialog v-model="load" :max-width="tamModal" :width="tamModal" :scrollable="$root.isTouch == false" :fullscreen="$root.isTouch"
            persistent>
            <v-card elevation="11">
                  <v-card-title class="bg-title-card">
                        <span class="white--text headline" v-html="'Informe de Notificación'"></span>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" rounded outlined @click="close();onUpdateNotification('L')">
                              <v-icon color="white">close</v-icon>
                        </v-btn>
                  </v-card-title>
                  <v-card-text>
                        <v-container fluid grid-list-sm>
                              <v-row dense>
                                    <v-col cols="12" sm="12">
                                          <v-tabs v-model="tab" background-color="transparent" grow color="blue-grey darken-1" :centered="!$root.isTouch">
                                                <v-tab v-for="(item) in cabNotificacion" :key="item.tipoNotificacion">
                                                      <span v-html="item.tipoNotificacion" class="blue-grey--text body-2"></span>
                                                </v-tab>
                                          </v-tabs>

                                          <v-tabs-items v-model="tab">
                                                <v-tab-item v-for="(item,k) in cabNotificacion" :key="k">
                                                      <v-card flat>
                                                            <v-card-text>
                                                                  <v-list dense>
                                                                        <v-list-item v-for="(v, k) in list" :key="k" three-line dense>
                                                                              <v-list-item-content>
                                                                                    <v-row dense :class="v.estadoNotificacion == 'N' ? 'red lighten-5' : '' ">
                                                                                          <v-col cols="12" sm="2">
                                                                                                <div class="text-center pt-3 pb-3">
                                                                                                      <v-img :src="v.icono" min-height="40" max-height="40" contain ></v-img>
                                                                                                </div>
                                                                                          </v-col>
                                                                                          <v-col cols="12" sm="10">
                                                                                                <v-list-item-title>
                                                                                                      <p class="text-left font-weight-bold button" v-html="v.tituloNotificacion"></p>
                                                                                                </v-list-item-title>
                                                                                                <v-list-item-subtitle>
                                                                                                      <p class="text-justify caption" v-html="v.notificacion"></p>
                                                                                                </v-list-item-subtitle>
                                                                                                <v-list-item-subtitle>
                                                                                                      <p class="text-right font-weight-bold caption" v-html="v.fechaNotificacion"></p>
                                                                                                </v-list-item-subtitle>
                                                                                          </v-col>
                                                                                    </v-row>
                                                                              </v-list-item-content>
                                                                        </v-list-item>
                                                                  </v-list>
                                                            </v-card-text>
                                                      </v-card>
                                                </v-tab-item>
                                          </v-tabs-items>

                                    </v-col>
                              </v-row>
                        </v-container>
                  </v-card-text>
            </v-card>
      </v-dialog>
</template>

<script>
      export default {
            name: 'ModalNotificacionComponent',
            inject: ['close'],
            props: {
                  load: {
                        type: Boolean,
                        default: false
                  }
            },
            data: () => ({
                  cabNotificacion: [],
                  listNotificacion: [],
                  tab: null,
                  list:[]
            }),
            watch: {
                  load(val) {
                        this.cabNotificacion    = [
                              {tipoNotificacion:'Beneficios (Regalos)'},
                              {tipoNotificacion:'Avisos'}
                        ];
                        this.listNotificacion   = [];
                        this.tab                = null;
                        this.list               = [];
                        if (val)
                              this.onList('L');
                  },
                  tab(val){
                        var l = [];
                        this.list = [];
                        if(_.toNumber(val) == 0)
                              l = _.filter(this.listNotificacion,{'agrupar':'1'});
                        else
                              l = _.filter(this.listNotificacion,{'agrupar':'0'});
                        
                        this.list = _.orderBy(l,['fechaNotificacion','idNotificacion'],['desc','desc']);
                        // console.info(this.list)
                  }
            },
            methods: {
                  onList(ev) {
                        if (!_.isUndefined(ev)) {
                              var error = 'E';
                              var o = {
                                    opcion: 'LISTAR',
                                    idCliente: _.get(this.$root, ['obUsuario', 'idCliente'], null)
                              }

                              axios.post(`${BASE_URI}administrador/notificacion/listar`, o)
                                    .then((r) => {
                                          if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                                          if (_.size(_.get(r, ['data', 'data'], [])) == 0) { error = 'I'; throw _.get(r, ['data', 'mensaje'], mensajeEstandar.errorPeticion) }
                                                var l = r.data.data;
                                                l = _.map(l, (v) => { 
                                                                        v.path = _.replace(v.path, 'imagenes', 'img'); 
                                                                        v.icono = require(`@/assets/${v.path}`);
                                                                        return v; 
                                                                  });
                                                this.listNotificacion = _.orderBy(l,['fechaNotificacion','idNotificacion'],['desc','desc']);
                                                this.list = _.filter(_.cloneDeep(this.listNotificacion),{'agrupar':'1'});
                                                // console.info(this.listNotificacion,this.list)
                                                return this.onUpdateNotification('U');
                                    })
                                    .catch((ex) => {
                                          mensajesAlerta(ex, error);
                                    });
                        }
                  },
                  onUpdateNotification(ev){
                        if(!_.isUndefined(ev)){
                              var data = {
                                    opcion: 'UM',
                                    listaNotificacion: _.map(_.get(this.$root,['notifications','data'],[]),_.partialRight(_.pick,['idNotificacion','idCliente']))
                              }
                              var url = `${BASE_URI}administrador/notificacion/insertOrUpdate`;
                              fetch(url,{
                                    method: 'POST',
                                    body: JSON.stringify(data), // data can be `string` or {object}!
                                    headers:{
                                          'Authorization': localStorage.getItem('token'), 
                                          'Content-Type': 'application/json'
                                    }
                              })
                        }
                  }
            }
      }
</script>